import React, {useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faChevronLeft,
    faLock
} from "@fortawesome/free-solid-svg-icons";
import {toFarsiNumber} from "../../utils/commonUtils";


const SectionBar = ({
                        title,
                        rank,
                        children,
                        enabled = true
                    }) => {

    const [isOpen, setIsOpen] = useState(false);


    const handleClick = () => {

        if (!enabled) {
            return;
        }

        setIsOpen(!isOpen);
    };


    return (
        <>

            <div
                onClick={handleClick}
                className={`
    ${enabled && isOpen ? 'rounded-t-lg' : 'rounded-lg'}
    relative
    mt-8
    border-4
    border-gray-200
    p-4
    lg:p-8
    flex
    justify-between
    items-center

    ${
                    enabled
                        ? 'cursor-pointer bg-gray-100 hover:bg-gray-200 transition'
                        : 'cursor-not-allowed bg-gray-300 opacity-50'}`}>

                <div className="flex items-center gap-x-3">
                    <div
                        className="
                            w-12
                            h-12
                            lg:w-16
                            lg:h-16
                            lg:text-xl
                            text-lg
                            font-bold
                            bg-gray-200
                            rounded-full
                            flex
                            items-center
                            justify-center
                        "
                    >
                        <span>
                            {toFarsiNumber(rank)}
                        </span>
                    </div>


                    <h2 className="font-bold text-2xl mr-5">
                        {title}
                    </h2>

                </div>


                <div>

                    {!enabled ? (

                        <FontAwesomeIcon
                            icon={faLock}
                            className="h-6"
                        />

                    ) : (

                        isOpen ? (

                            <FontAwesomeIcon
                                icon={faChevronLeft}
                                className="-rotate-90 transition h-4 lg:h-4"
                            />

                        ) : (

                            <FontAwesomeIcon
                                icon={faChevronLeft}
                                className="transition h-4 lg:h-6"
                            />

                        )

                    )}

                </div>

            </div>


            {enabled && (

                <div
                    className="
                        w-full
                        bg-gray-100
                        border-4
                        rounded-b-lg
                        transition
                    "
                    style={{
                        display: isOpen ? 'block' : 'none'
                    }}
                >
                    {children}
                </div>

            )}

        </>
    );
};


export default SectionBar;